// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
const firebaseConfig = {
    apiKey: 'AIzaSyCCHRzYcpf6Kji9qFtNKvIdNlV3hNH6sFU',
    authDomain: 'acemoneybusiness-302c4.firebaseapp.com',
    projectId: 'acemoneybusiness-302c4',
    storageBucket: 'acemoneybusiness-302c4.firebasestorage.app',
    messagingSenderId: '1042352545627',
    appId: '1:1042352545627:web:c3dde6198d73aa7fbb847e',
    measurementId: 'G-RPB3VQGE2Z'
};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

export { messaging, getToken, onMessage };
